<template>
  <el-container class="pagination-list data-management-container">
    <el-main class="pagination-body">
      <div class="content">
        <el-form :inline="true" :model="management" ref="management" @submit.native.prevent>
          <el-form-item label="数据名" prop="dataName">
            <el-input
              v-model="management.dataName"
              placeholder="请输入数据名"
              @keyup.enter.native="search"
              clearable
            />
          </el-form-item>
          <el-form-item label="数据类型" prop="dataType">
            <el-input
              v-model="management.dataType"
              placeholder="请输入数据类型"
              @keyup.enter.native="search"
              clearable
            />
          </el-form-item>
          <!--操作按钮-->
          <el-form-item class="operation-btns">
            <el-button @click="search">查询</el-button>
            <el-button @click="reset">重置</el-button>
            <el-button type="primary" @click="addData">添加</el-button>
          </el-form-item>
        </el-form>
        <table-list
          :type="'management'"
          :items="items"
          :cols="cols"
          :loading="loading"
          :pagination="pagination"
          @dataImport="dataImport"
          @changePagination="getTableData"
          @editRow="editRow"
          @delRow="delRow"
        ></table-list>
        <el-dialog class="import-data" title="报表数据导入" :visible.sync="toLead">
          <a class="download" size="small" @click="downloadTemplate">数据名 {{fileNameShow}}.xls 模板下载</a>
          <i class="el-icon-question" @mouseover="helpIcon" @mouseout="hiddenIcon"></i>
          <el-upload
            class="upload"
            ref="upload"
            accept=".xls, .xlsx"
            :limit="1"
            action="/data-api/table/uploadDataTemplate"
            :data="uploading"
            :headers="headers"
            :auto-upload="false"
            :before-upload="checkFile"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :on-exceed="overLimit"
            :on-change="updateFile"
          >
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
            <el-button size="small" type="success" @click="submitUpload">上传到服务器</el-button>
            <div class="tips" slot="tip">只能上传*.xls或者*.xlsx格式文档</div>
          </el-upload>
          <div class="tip-img" v-show="showTips">
            <img src="../../assets/images/showTip.png" alt>
          </div>
        </el-dialog>
        <el-dialog title="删除数据" :visible.sync="delData">
          <div v-for="(data,index) in deleteAssociated" :key="index">{{data}}</div>
          <div slot="footer">
            <el-button type="primary" @click="onDelete">确 认</el-button>
            <el-button @click="delData = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import TableList from './table-list.vue'
import tokenStorage from '@/plugins/tokenStorage'
export default {
  name: 'dataManagement',
  components: {
    TableList
  },
  data () {
    return {
      fileNameShow: '',
      showTips: false,
      deleteTable: false,
      deleteAssociated: [],
      uploading: { tableId: '' },
      management: { dataName: '', dataType: '' },
      pagination: {
        currentPage: 1,
        pageSize: 20,
        pageSizes: [20, 35, 50],
        total: 0
      },
      relevanceAttr: {},
      fileList: [],
      loading: false,
      delData: false,
      toLead: false,
      tableId: '',
      cols: [
        { prop: 'id', label: '数据ID', width: '310px' },
        { prop: 'name', label: '数据名', width: '140PX' },
        { prop: 'dataType', label: '数据类型', width: '310px' },
        { prop: 'tableName', label: '实际表名', width: '140PX' }
      ],
      filters: {},
      items: []
    }
  },
  created () {
    this.headers = {
      Authorization: tokenStorage.getToken()
    }
    this.getTableData()
  },
  beforeRouteEnter (to, from, next) {
    if (from.path.includes('/data-management-detail')) {
      next(vm => {
        let _this = vm
        _this.getTableData()
      })
    } else {
      next()
    }
  },
  methods: {
    // 获取后台数据
    getTableData () {
      let params = {
        index: this.pagination.currentPage,
        size: this.pagination.pageSize
      }
      params.filters = this.filters
      this.$axios.get(`/data-api/table/list`, { params }).then(res => {
        if (res.status === 200) {
          this.pagination.total = res.data.total
          this.items = res.data.items
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    checkFile (file) {
      let type = file.name.split('.')
      let fileType = type[type.length - 1]
      if (fileType !== 'xls' && fileType !== 'xlsx') {
        this.$message.warning('文件格式错误,请上传*.xls或者*.xlsx格式文档')
        return false
      }
    },
    search () {
      this.pagination.currentPage = 1
      // 查询条件
      this.filters = {
        keyword: this.management.dataName
      }
      this.getTableData()
    },
    reset () {
      this.management.dataType = ''
      this.management.dataName = ''
      this.pagination.currentPage = 1
      this.filters = {}
      this.getTableData()
    },
    editRow (row) {
      this.$router.push({
        name: 'dataManagementDetail',
        params: { id: row.id }
      })
    },
    // 获取此表的关联属性,如有关联禁止删除
    delRow (row) {
      this.deleteAssociated[0] = `是否确认删除该关联表`
      this.deleteTable = false
      this.tableId = row.id
      this.delData = true
      this.$axios
        .get(`/data-api/table/deleteCheck/${this.tableId}`)
        .then(res => {
          this.deleteAssociated = []
          if (res.data.length > 0) {
            this.deleteTable = true
            for (let i = 0; i < res.data.length; i++) {
              this.deleteAssociated.push(` ${res.data[i]}`)
            }
          } else {
            this.deleteAssociated.push(`是否确认删除该关联表`)
          }
        })
    },
    onDelete () {
      if (this.deleteTable) {
        this.delData = false
        return false
      }
      this.$axios.delete(`/data-api/table/${this.tableId}`).then(res => {
        if (res.status === 200) {
          this.$message.success('删除成功')
          this.delData = false
          this.getTableData()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    dataImport (data) {
      this.fileNameShow = data.name
      this.uploading.tableId = data.id
      this.toLead = true
    },
    submitUpload () {
      if (this.fileList.length === 0) {
        this.$message.warning('请选择上传文件')
        return
      }
      this.$refs.upload.submit()
    },
    downloadTemplate () {
      this.$axios({
        method: 'get',
        url: `/data-api/table/downDataTemplate/${this.uploading.tableId}`
      }).then(res => {
        if (res.data && res.data[0] && res.data[0].status === 'success') {
          let ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
          window.open(`${ossDownloadUrl}${res.data[0].result.dir}`)
        }
        // if (!data) {
        //   return
        // }
        // let fileName = decodeURI(
        //   data.headers['content-disposition'].split('=')[1]
        // )
        // let blob = new Blob([data.data])
        // let url = window.URL.createObjectURL(blob)
        // if ('download' in document.createElement('a')) {
        //   // 非IE下载
        //   let link = document.createElement('a')
        //   link.style.display = 'none'
        //   link.href = url
        //   link.setAttribute('download', `${fileName}`)
        //   document.body.appendChild(link)
        //   link.click()
        //   URL.revokeObjectURL(link.href)
        //   document.body.removeChild(link)
        // } else {
        //   navigator.msSaveBlob(blob, fileName)
        // }
      })
    },
    uploadSuccess () {
      this.$message.success('文件上传成功!')
    },
    uploadError () {
      this.$message.error('解析失败!')
    },
    overLimit () {
      this.$message.warning('最多上传一个文件')
    },
    // 记录选择的文件
    updateFile (files, fileList) {
      this.fileList = fileList
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    },
    addData () {
      this.$router.push({ name: 'dataManagementDetail' })
    },
    helpIcon () {
      this.showTips = true
    },
    hiddenIcon () {
      this.showTips = false
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";
  #app .pagination-list .import-data .el-dialog {
    overflow: visible;
  }
  .pagination-list .import-data .el-dialog {
    width: 450px;
    text-align: center;
    position: relative;
    overflow: visible;
    .download {
      cursor: pointer;
      display: inline-block;
      padding-bottom: 5px;
      color: #62a8f2;
      &:hover {
        color: #0077aa;
      }
    }
    .tip-img {
      width: 508px;
      position: absolute;
      top: 105%;
      left: -50%;
      margin-left: 196px;
    }
    .download {
      margin-bottom: 20px;
    }
    .tips {
      margin-top: 10px;
    }
  }

  .data-management-container .el-main .content .el-input .el-input__inner {
    height: 28px;
    line-height: 28px;
  }

  .data-management-container {
    padding: 10px;
    height: 100%;

    div,
    span,
    p,
    label {
      font-size: 12px;
    }

    .pagination-body {
      background: #fff;
      box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
      border-radius: 4px 0;
      height: 100%;

      .content {
        .el-form {
          position: relative;

          .operation-btns {
            position: absolute;
            right: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/data/data-management.vue